import { render } from "./resetPassword.vue?vue&type=template&id=a480cd34&scoped=true"
import script from "./resetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./resetPassword.vue?vue&type=script&setup=true&lang=js"

import "./resetPassword.vue?vue&type=style&index=0&id=a480cd34&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a480cd34"],['__file',"pages/EndataAuth/Account/App/components/profile/resetPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a480cd34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a480cd34', __exports__)) {
    api.reload('a480cd34', __exports__)
  }
  
  module.hot.accept("./resetPassword.vue?vue&type=template&id=a480cd34&scoped=true", () => {
    api.rerender('a480cd34', render)
  })

}


export default __exports__